import React, { useState } from "react";
import HamburgerMenu from "./HamburgerMenu";
import wwebg from "./assets/wwebg.png";

export default function WhatWeEvaluate() {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen((open) => !open);

  const criteria = [
    {
      title: "Centering",
      description: "You'll receive a centering score front and back (ex. 55/45).",
    },
    {
      title: "Edges",
      description: "Cleanliness, dings, or whitening on the card’s perimeter.",
    },
    {
      title: "Corners",
      description: "Sharpness and wear of all four corners.",
    },
    {
      title: "Surface",
      description: "Scratches, print lines, and other imperfections on the card face.",
    },
    {
      title: "Expected vs. Ceiling Grade",
      description: "Realistic grade expectation and highest possible grade.",
    },
    {
      title: "Expected Grade Valuation",
      description: "Market-based valuation based on expected grade",
    },
  ];

  return (
    <div
      className="min-h-screen text-white font-[Montserrat] flex flex-col"
      style={{
        backgroundImage: `url(${wwebg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Header Bar (only hamburger) */}
      <nav className="flex justify-end items-center px-6 py-4 relative z-20">
        <HamburgerMenu menuOpen={menuOpen} toggleMenu={toggleMenu} />
      </nav>

      {/* Page Content */}
      <section className="w-full py-14 px-4 flex flex-col items-center">
        <h2 className="text-3xl font-extrabold text-center mb-10 tracking-tight">
          What We Evaluate
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl w-full">
          {criteria.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-black bg-opacity-80 p-6 border border-white"
            >
              <h3 className="text-xl font-bold mb-2">{item.title}</h3>
              <p className="text-gray-300 text-sm">{item.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
